import { useContext } from 'react';

import { TestInputs } from './ABLincoln';
import { ABLincolnContext } from './ABLincolnContextProvider';

/**
 * Returns a function that you can use to get the experiment parameter value.
 *
 * To bucket immediately when the hook is invoked:
 * const bucket = useABLincoln()('namespace', 'param', 'default');
 *
 * Alternatively, you can use the function this hook returns anywhere in your component:
 * ```
 * const getTestValue = useABLincoln();
 * const onClickHandler = () => {
 *   const bucket = getTestValue('namespace', 'param', 'default');
 * }
 * ```
 */
export function useABLincoln() {
  const ablincoln = useContext(ABLincolnContext);

  return (testGroupName: string, paramName: string, defaultValue: string, inputs?: TestInputs) => {
    try {
      if (ablincoln) {
        if (inputs) {
          return ablincoln
            .getTest(testGroupName)
            ?.setInputs(inputs)
            .getTestValue(testGroupName, paramName, defaultValue);
        } else {
          return ablincoln.getTestValue(testGroupName, paramName, defaultValue);
        }
      }
      return defaultValue;
    } catch {
      return defaultValue;
    }
  };
}
